import React from "react"
import {
  Outlet,
  useLoaderData,
  useRouteLoaderData,
  redirect,
} from "react-router-dom"

import { Datasets, Schemas, CurrentOrgId } from "../lib/store"
import { Api } from "../lib/api"
import { isEmpty } from "../lib/util"

export default function FetchDatasetsSchemas() {
  const user = useRouteLoaderData("auth")
  const [datasets] = useLoaderData()

  if (!datasets || !user) return <></>
  return <Outlet />
}

FetchDatasetsSchemas.loader = async () => {
  console.log("FetchDatasetsSchemas.loader fetching datasets and schemas")

  // If we're missing either datasets or schemas, fetch them
  if (isEmpty(Datasets.getValue()) || isEmpty(Schemas.getValue())) {
    let currentOrgId = CurrentOrgId.getValue()

    // If no current org id is found in state, try to fetch organization data
    if (!currentOrgId) {
      console.log(
        "No current org id in state, attempting to fetch user organizations",
      )
      const api = new Api()

      try {
        // Try to get the user's organizations
        const organizations = await api.organizationsList()

        if (organizations && organizations.length > 0) {
          // Set the organization in state and get the ID
          api.setOrFindOrganization(organizations)
          currentOrgId = CurrentOrgId.getValue()
          console.log("Successfully loaded organization data", currentOrgId)
        }
      } catch (error) {
        console.error("Error fetching organization data:", error)
      }

      // If we still don't have an organization, redirect to create one
      if (!currentOrgId) {
        console.log("No organizations found, redirecting to create")
        return redirect("/organizations/create")
      }
    }

    const api = new Api()
    const datasets = await api.datasetsList(currentOrgId)
    const schemas = await api.schemasList()
    return [datasets, schemas]
  }

  // Otherwise use stored state
  return [Datasets.getValue(), Schemas.getValue()]
}
